import styled from "styled-components";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";
import {
  pillDiameter,
  type PillSizeKey,
} from "../../../design-system/tokens/controlSizes";
import { duration, easing } from "../../../design-system/tokens/transitions";

export const PillButton = styled.button<{
  $selected: boolean;
  $size: PillSizeKey;
  $compact: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Never shrink. As a flex item the default flex-shrink of 1 squashes the
     pill into an ellipse once the row runs out of room — visible at a 320px
     viewport, where a seven-pill week row measured 34.3 x 36. A circle is the
     whole point of this atom. */
  flex: 0 0 auto;
  box-sizing: border-box;
  width: ${({ $size }) => pillDiameter($size)};
  height: ${({ $size }) => pillDiameter($size)};
  border-radius: 50%;
  cursor: pointer;
  ${({ $compact }) =>
    $compact ? typographyMixin("caption", 3) : typographyMixin("body", 3)}
  /* Figma: selected days are SemiBold, unselected Medium — the weight is part
     of the selected state, not just the colour. Overrides the mixin above. */
  font-weight: ${({ $selected }) => ($selected ? 600 : 500)};
  background-color: ${({ $selected }) =>
    $selected ? rawColors.primary[100] : rawColors.grey[300]};
  color: ${({ $selected }) =>
    $selected ? rawColors.primary[500] : rawColors.text.mediumEmphasis};
  border: 1px solid
    ${({ $selected }) =>
      $selected ? rawColors.primary[100] : rawColors.grey[300]};
  transition: background-color ${duration.fast} ${easing.smooth}, color ${duration.fast} ${easing.smooth},
    border-color ${duration.fast} ${easing.smooth}, font-weight ${duration.fast} ${easing.smooth};

  &:hover {
    border-color: ${rawColors.primary[500]};
  }

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 2px;
  }
`;
